import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IpMaskInput = (props) => {
  const {
    handleChange,
    value,
    onKeyDown = () => {},
    id = ''
  } = props;

  const allIconClasses = classNames({
    'input-group-text': true,
    'rounded-right': true,
    'color-dark': true,
    'add-ip': true,
    'icon-with-pointer': true
  });

  const onIconClick = (e) => {
    const { handleIconClick = () => {} } = props;
    handleIconClick(e);
  };

  const mask = (value) => {
    let result = [];
    const twoParts = value.split('/');
    const [ip, range] = twoParts;
    const chunks = ip.split('.');

    for (let i = 0; i < 4; ++i) {
      const chunk = (chunks[i] || '').replace(/_/gi, '');
      if (chunk === '') {
        result.push(/\d/, /\d/, /\d/, '.');
      } else if (+chunk === 0) {
        result.push(/\d/, '.');
      } else if (chunks.length < 4 || (chunk.length < 3 && chunks[i].indexOf('_') !== -1)
      ) {
        if ((chunk.length < 2 && +`${chunk}00` > 255) || (chunk.length < 3 && +`${chunk}0` > 255)) {
          result.push(/\d/, /\d/, '.');
        } else {
          result.push(/\d/, /\d/, /\d/, '.');
        }
      } else {
        result.push(...new Array(chunk.length).fill(/\d/), '.');
      }
    }

    // remove dot
    result = result.slice(0, -1);

    // check if ip is full (without taking into account range)
    if (ip.indexOf('_') === -1 && ip.length > 1 && range !== undefined) {
      if (range.charAt(0) <= 3) {
        result.push('/', /\d/, /\d/);
      } else {
        result.push('/', /\d/);
      }
    }
    return result;
  };

  const pipe = (value) => {
    if (value === '.' || value.endsWith('..')) return false;
    const [ip, range] = value.split('/');
    const ipParts = ip.split('.');

    if (range === undefined && (ipParts.length > 4 || ipParts.some(part => part === '00' || part < 0 || part > 255))) {
      return false;
    }
    return value;
  };

  return (
    <div className="input-group default-input-group">
      <MaskedInput
        guide
        value={value}
        onKeyDown={onKeyDown}
        mask={mask}
        pipe={pipe}
        onChange={e => handleChange(e.target.value)}
        className="form-control"
      />
      <div className="input-group-append">
        <span className={allIconClasses} id={`${id}Addon`} onClick={onIconClick} onKeyPress={onIconClick}>
          <FontAwesomeIcon icon={{ iconName: 'plus', prefix: 'fal' }} />
        </span>
      </div>
    </div>
  );
};

PropTypes.propTypes = {
  inputRef: PropTypes.func.isRequired
};

export default IpMaskInput;
